import React, {useEffect} from 'react';
import ViewAnnotationsSnackBar from '../SnackBars/ViewAnnotationsSnackBar';

const ViewAnnotationsPanel = (props) => {

    const {
        editor,
        selectedPage,
        selectedProject
    } = props;

    const [openViewAnnotationsSnackBar, setOpenViewAnnotationsSnackBar] = React.useState(false);

    useEffect(() => {
        if (selectedPage > -1 && selectedProject > -1 && editor.BlockManager !== undefined) {
            editor.on('run:view-annotations', () => {
            
                setOpenViewAnnotationsSnackBar(true);
                
            });
            editor.on('stop:view-annotations', () => {
            
                setOpenViewAnnotationsSnackBar(false);
            });
        }
    },[selectedPage, selectedProject]);

    return(
        <>
            <div
            className="view_annotations"
            style={selectedPage < 0 ? { display: 'none' } : null}
            />
            <ViewAnnotationsSnackBar
                openViewAnnotationsSnackBar={openViewAnnotationsSnackBar}
                setOpenViewAnnotationsSnackBar={setOpenViewAnnotationsSnackBar}
            />
        </>
    )

}

export default ViewAnnotationsPanel;
